(function () {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;

    const variantControllerLib = window.EEGVariantController;
    const parseJson = variantControllerLib && typeof variantControllerLib.parseJson === 'function'
        ? variantControllerLib.parseJson
        : (element) => {
            if (!element) return null;
            try {
                return JSON.parse(element.textContent);
            } catch (error) {
                return null;
            }
        };

    const variants = parseJson(section.querySelector('[data-variants-json]')) || [];
    const priceList = parseJson(section.querySelector('[data-variant-price-map]')) || [];
    const variantPriceMap = new Map(priceList.map((variant) => [String(variant.id), variant]));
    const cartList = parseJson(section.querySelector('[data-variant-cart-map]')) || [];
    const variantCartMap = new Map(cartList.map((entry) => [String(entry.id), Number(entry.quantity || 0)]));

    const optionGroups = section.querySelectorAll('[data-product-option]');
    const optionInputs = section.querySelectorAll('[data-product-option-input]');
    const variantIdInput = section.querySelector('input[name="id"]');
    const priceEl = section.querySelector('[data-product-price]');
    const comparePriceEl = section.querySelector('[data-compare-price]');
    const addToCartBtn = section.querySelector('[data-add-to-cart]');
    const addToCartLabel = section.querySelector('[data-add-to-cart-label]');
    const addToCartText = addToCartBtn ? addToCartBtn.getAttribute('data-add-to-cart-text') : '';
    const soldOutText = addToCartBtn ? addToCartBtn.getAttribute('data-sold-out-text') : '';
    const productForm = section.querySelector('[data-product-form]');
    const errorMessage = section.querySelector('[data-product-error]');
    const quantityNote = section.querySelector('[data-quantity-note]');
    const inventoryEl = section.querySelector('[data-inventory-status]');
    const inventoryThreshold = inventoryEl ? parseInt(inventoryEl.getAttribute('data-inventory-threshold') || '5', 10) : 5;
    const inventoryStrings = {
        inStock: inventoryEl ? inventoryEl.getAttribute('data-in-stock-text') : '',
        lowStock: inventoryEl ? inventoryEl.getAttribute('data-low-stock-text') : '',
        backorder: inventoryEl ? inventoryEl.getAttribute('data-backorder-text') : '',
        outOfStock: inventoryEl ? inventoryEl.getAttribute('data-out-of-stock-text') : '',
    };
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const mediaState = {
        loadPromise: null,
        loaded: false,
        prefetched: false,
        failed: false,
    };

    const getMediaSrc = () => section.getAttribute('data-product-media-src') || '';

    const canPrefetchAssets = () => {
        if (window.EEGAssetLoader && typeof window.EEGAssetLoader.canPrefetchAssets === 'function') {
            return window.EEGAssetLoader.canPrefetchAssets();
        }
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!connection) return true;
        if (connection.saveData) return false;
        if (typeof connection.effectiveType === 'string' && connection.effectiveType.includes('2g')) return false;
        return true;
    };

    const prefetchProductMedia = () => {
        if (mediaState.prefetched) return;
        const src = getMediaSrc();
        if (!src || !document.head) return;
        if (!canPrefetchAssets()) return;

        mediaState.prefetched = true;
        if (document.querySelector('link[data-eeg-product-media-prefetch]')) return;

        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.as = 'script';
        link.href = src;
        link.setAttribute('data-eeg-product-media-prefetch', 'true');
        document.head.appendChild(link);
    };

    let cleanupMediaListeners = null;

    const loadProductMedia = () => {
        if (mediaState.loaded) return Promise.resolve();
        if (mediaState.loadPromise) return mediaState.loadPromise;
        const src = getMediaSrc();
        if (!src || !document.body) return Promise.resolve();

        mediaState.loadPromise = new Promise((resolve, reject) => {
            const existing = document.querySelector('script[data-eeg-product-media]');
            if (existing) {
                if (existing.getAttribute('data-eeg-loaded') === 'true') {
                    mediaState.loaded = true;
                    resolve();
                    return;
                }
                existing.addEventListener('load', () => {
                    mediaState.loaded = true;
                    resolve();
                }, { once: true });
                existing.addEventListener('error', () => {
                    mediaState.loadPromise = null;
                    mediaState.failed = true;
                    reject(new Error('Product media failed to load.'));
                }, { once: true });
                return;
            }

            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.setAttribute('data-eeg-product-media', 'true');
            script.onload = () => {
                script.setAttribute('data-eeg-loaded', 'true');
                mediaState.loaded = true;
                if (window.EEGProductMedia && typeof window.EEGProductMedia.init === 'function') {
                    window.EEGProductMedia.init();
                }
                resolve();
            };
            script.onerror = () => {
                mediaState.loadPromise = null;
                mediaState.failed = true;
                reject(new Error('Product media failed to load.'));
            };
            document.body.appendChild(script);
        }).then(() => {
            if (cleanupMediaListeners) {
                cleanupMediaListeners();
                cleanupMediaListeners = null;
            }
        });

        return mediaState.loadPromise;
    };

    const mediaTriggerSelector = '[data-thumb], [data-thumb-prev], [data-thumb-next], [data-media-trigger]';

    const bindMediaLoadListeners = () => {
        const handleMediaTrigger = (event) => {
            if (mediaState.loaded || mediaState.failed) return;
            const target = event.target instanceof Element ? event.target : null;
            if (!target) return;
            const trigger = target.closest(mediaTriggerSelector);
            if (!trigger) return;

            if (event.type === 'keydown') {
                const code = (event.code || '').toUpperCase();
                if (code !== 'SPACE' && code !== 'ENTER') return;
            }

            event.preventDefault();
            event.stopPropagation();

            loadProductMedia()
                .then(() => {
                    if (trigger && trigger.isConnected) {
                        trigger.click();
                    }
                })
                .catch(() => { });
        };

        const handlePrefetch = (event) => {
            if (mediaState.prefetched || mediaState.loaded) return;
            const target = event.target instanceof Element ? event.target : null;
            if (!target) return;
            if (!target.closest(mediaTriggerSelector) && !target.closest('[data-product-gallery]')) return;
            prefetchProductMedia();
        };

        section.addEventListener('click', handleMediaTrigger, true);
        section.addEventListener('keydown', handleMediaTrigger, true);
        section.addEventListener('pointerover', handlePrefetch, { passive: true });
        section.addEventListener('focusin', handlePrefetch);

        cleanupMediaListeners = () => {
            section.removeEventListener('click', handleMediaTrigger, true);
            section.removeEventListener('keydown', handleMediaTrigger, true);
            section.removeEventListener('pointerover', handlePrefetch);
            section.removeEventListener('focusin', handlePrefetch);
        };
    };

    bindMediaLoadListeners();

    const gallery = section.querySelector('[data-product-gallery]');
    const gallerySlideCount = section.querySelectorAll('[data-gallery-slide]').length;
    const shouldAutoLoadMedia = window.innerWidth < 990 && gallerySlideCount > 1;

    const initGalleryStickyBottom = () => {
        if (!gallery) return;
        const desktopMedia = window.matchMedia('(min-width: 990px)');
        if (!desktopMedia.matches) return;

        let ticking = false;
        const scheduleUpdate = () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
                ticking = false;
                update();
            });
        };

        const update = () => {
            if (!desktopMedia.matches) return;

            const trigger = section.querySelector('.eeg-product__thumbs') || gallery;
            const galleryRect = gallery.getBoundingClientRect();
            const triggerRect = trigger.getBoundingClientRect();

            const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
            const bottomOffset = 1 * rem;
            const triggerBottomFromGalleryTop = triggerRect.bottom - galleryRect.top;
            const topOffset = window.innerHeight - bottomOffset - triggerBottomFromGalleryTop;

            gallery.style.setProperty('--eeg-product-gallery-sticky-top', `${topOffset}px`);
        };

        scheduleUpdate();
        window.addEventListener('resize', scheduleUpdate);
        window.addEventListener('load', scheduleUpdate, { once: true });

        if ('ResizeObserver' in window) {
            const ro = new ResizeObserver(() => scheduleUpdate());
            ro.observe(gallery);

            const thumbs = section.querySelector('.eeg-product__thumbs');
            if (thumbs) ro.observe(thumbs);
        }
    };

    initGalleryStickyBottom();

    const initThumbNavDisabledSync = () => {
        const thumbsTrack = section.querySelector('[data-thumbs-track]');
        const prevBtn = section.querySelector('[data-thumb-prev]');
        const nextBtn = section.querySelector('[data-thumb-next]');
        if (!thumbsTrack || !prevBtn || !nextBtn) return;
        if (thumbsTrack.getAttribute('data-eeg-thumb-nav-sync') === 'true') return;
        thumbsTrack.setAttribute('data-eeg-thumb-nav-sync', 'true');

        const update = () => {
            const maxScroll = thumbsTrack.scrollWidth - thumbsTrack.clientWidth;
            prevBtn.disabled = thumbsTrack.scrollLeft <= 0;
            nextBtn.disabled = thumbsTrack.scrollLeft >= maxScroll - 1;
        };

        let ticking = false;
        const scheduleUpdate = () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
                update();
                ticking = false;
            });
        };

        thumbsTrack.addEventListener('scroll', scheduleUpdate, { passive: true });
        window.addEventListener('resize', scheduleUpdate);
        scheduleUpdate();
        window.addEventListener('load', update, { once: true });
    };

    if (shouldAutoLoadMedia) {
        loadProductMedia().catch(() => { });
    } else if (gallery && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            prefetchProductMedia();
            observer.disconnect();
        }, { rootMargin: '200px' });
        observer.observe(gallery);
    }

    // On desktop, keep the media script lazy-loaded but precompute thumb nav disabled state.
    if (!shouldAutoLoadMedia) {
        initThumbNavDisabledSync();
    }

    if (optionInputs.length) {
        optionInputs.forEach((input) => {
            input.addEventListener('pointerenter', prefetchProductMedia, { passive: true, once: true });
            input.addEventListener('focus', prefetchProductMedia, { once: true });
        });
    }

    let isInitialSync = true;
    const variantController = variantControllerLib && typeof variantControllerLib.create === 'function'
        ? variantControllerLib.create({
            variants,
            variantPriceMap,
            variantCartMap,
            optionGroups,
            optionInputSelector: '[data-product-option-input]',
            optionValueSelector: '[data-product-option-value]',
            variantIdInput,
            priceEl,
            comparePriceEl,
            addToCartBtn,
            addToCartLabel,
            addToCartText,
            soldOutText,
            inventoryEl,
            inventoryThreshold,
            inventoryStrings,
            quantityNote,
            onVariantChange: (matchedVariant) => {
                const featuredMediaId = matchedVariant.featured_media?.id || matchedVariant.featured_image?.id;
                if (!featuredMediaId || isInitialSync) return;
                loadProductMedia()
                    .then(() => {
                        if (window.EEGProductMedia && typeof window.EEGProductMedia.setActiveMediaById === 'function') {
                            window.EEGProductMedia.setActiveMediaById(featuredMediaId, {
                                scrollViewer: true,
                                scrollThumbs: true,
                                behavior: prefersReducedMotion ? 'auto' : 'smooth',
                                force: true,
                            });
                        }
                    })
                    .catch(() => { });
            },
        })
        : null;

    const handleAddToCart = () => {
        if (!productForm) return;
        if (!window.EEGCartAdd || typeof window.EEGCartAdd.addToCartFromForm !== 'function') return;
        window.EEGCartAdd.addToCartFromForm({
            form: productForm,
            submitButton: addToCartBtn,
            errorContainer: errorMessage,
            source: 'product-form',
            onCart: (cart) => {
                if (variantController && typeof variantController.updateCartFromCart === 'function') {
                    variantController.updateCartFromCart(cart);
                }
            },
        });
    };

    const updateVariantSelection = () => {
        if (!variantController || typeof variantController.updateSelection !== 'function') return;
        variantController.updateSelection();
    };

    if (addToCartBtn && productForm) {
        addToCartBtn.addEventListener('click', (event) => {
            event.preventDefault();
            handleAddToCart();
        });
    }

    if (optionInputs.length) {
        optionInputs.forEach((input) => {
            input.addEventListener('change', () => {
                updateVariantSelection();

                const group = input.closest('[data-product-option]');
                const labelText = group ? group.querySelector('[data-option-selected-text]') : null;
                if (labelText) {
                    labelText.textContent = input.value;
                }
            });
        });
    }

    updateVariantSelection();
    isInitialSync = false;
    if (variantIdInput && variantController && typeof variantController.updateQuantityNote === 'function') {
        variantController.updateQuantityNote(variantIdInput.value);
    }

    const accordions = section.querySelectorAll('[data-accordion]');
    accordions.forEach((accordion) => {
        const toggle = accordion.querySelector('[data-accordion-toggle]');
        const content = accordion.querySelector('[data-accordion-content]');

        if (toggle && content) {
            toggle.addEventListener('click', () => {
                const isOpen = content.classList.contains('is-open');

                // Disable mutual exclusivity: allow multiple rows to expand to avoid layout jumps.
                // if (window.matchMedia('(min-width: 990px)').matches) { ... }

                if (isOpen) {
                    content.classList.remove('is-open');
                    toggle.setAttribute('aria-expanded', 'false');
                } else {
                    content.classList.add('is-open');
                    toggle.setAttribute('aria-expanded', 'true');
                }
            });
        }
    });
})();
